import { LOGIN_SUCCESS, LOGOUT, UPDATE_PROFILE } from "action/AuthAction";

const initialState: any = {
  isAuthenticated: false,
  token: null,
  profile: null,
  forgotPassword: {
    sessionId: '',
    email: '',
    code: '',
    newPassword: ''
  },
  sessionId: ''
};

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        profile: action.payload.profile,
        sessionId: action.payload.sessionId
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        }
      };
    case LOGOUT:
      return initialState;
    case 'REQUEST_FORGOT_PASSWORD':
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          sessionId: action.payload.sessionId,
          email: action.payload.email,
        }
      };
    default:
      return state;
  }
};

export default authReducer;